import React, { useEffect, useState } from "react";
import orderModel from "../../model/order.model";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FaArrowCircleLeft } from "react-icons/fa";
import back from "../../Asset/product/back.png";
import Address from "../../component/orderdetail/Addressdata";
import Tracking from "../../component/orderdetail/Tracking";
import Orderdetaildata from "../../component/orderdetail/Orderdetaildata";
import Addressdata from "../../component/orderdetail/Addressdata";

const OrderDetail = () => {
  const Navigate = useNavigate();
  const parms = useParams();
  const [data, setData] = useState();

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location?.pathname]);

  const GetDetail = async () => {
    orderModel
      .GetOrdersDetail(parms?.id)
      .then((responce) => {
        setData(responce?.data?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  useEffect(() => {
    GetDetail();
  }, []);

  return (
    <div className="w-full bg-Background3 px-10 pt-10 pb-40" style={{ backgroundImage: `url(${back})`}}>
      <div className="flex gap-5 items-center text-2xl font-semibold text-textColor">
        <span >
          <FaArrowCircleLeft
            onClick={() => {
              Navigate("/order");
            }}
            className="cursor-pointer text-4xl"
          />
        </span>
        <span>Orders</span>
      </div>
      <div className="grid md:grid-cols-2 grid-cols-1 gap-10 mt-10 ">
        <div className="w-full">
          <Orderdetaildata datalist={data} Get={GetDetail}/>
        </div>
        <div className="w-full">
          <Addressdata datalist={data} />
        </div>
        <div className="w-full">
          <Tracking datalist={data?.order_tracking} />
        </div>
      </div>
    </div>
  );
};

export default OrderDetail;
